import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Header, Loader } from 'semantic-ui-react';
import ScrollableCards from '@/components/cards/ScrollableCards';
import { states } from '@/constants/lifecycle';
import Error from '@/components/errors/Error';
import { firstErrorMessage } from '@/utils/errors';
import NoRowsWrapper from '@/components/table/NoRowsWrapper';
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb';
import RequestAttachmentsFilters from './RequestAttachmentsFilters';
import RequestAttachmentCardItems from './RequestAttachmentCardItems';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestAttachmentsCards = ({ category, code }) => {
  const {
    attachments, readStatus, readErrors, isRoot, segments,
  } = Selectors.useRequestAttachmentsCards({ category, code });
  const onSelect = Events.useToggleRequestAttachmentSelected(category, { code });
  const onFolderClick = Events.useRequestAttachmentFolderPush(category, { code });
  const onNavigate = Events.useRequestAttachmentFolderNavigate(category, { code });

  return (
    <div className="aridhia-attachments-list">
      <Header as="h4">
        <FormattedMessage id="table.header.attachments.title" />
      </Header>
      <div className="sticky-panel-header">
        <RequestAttachmentsFilters className="aridhia-list-filter mb-10" category={category} code={code} fluid />
      </div>
      {!isRoot && (
        <div className="flex items-center mt-10 mb-10">
          <Breadcrumb segments={segments} onNavigate={onNavigate} />
        </div>
      )}
      {readStatus === states.PENDING && (
        <div className="flex items-center mt-10 mb-10">
          <Loader active inline="centered" />
        </div>
      )}
      {readStatus === states.ERROR && (
        <div className="flex items-center mt-10 mb-10">
          <Error error={firstErrorMessage(readErrors)} />
        </div>
      )}
      <NoRowsWrapper
        className="aridhia-attachment-cards"
        icon="file alternate outline"
        entity="request.attachments"
        readErrors={[]}
        readStatus={[readStatus]}
        items={attachments}
        loading
      >
        <ScrollableCards itemsPerRow={1}>
          <RequestAttachmentCardItems
            attachments={attachments}
            onCheckBoxClick={isRoot ? (attachmentId) => onSelect({ attachmentId }) : undefined}
            onFolderClick={onFolderClick}
          />
        </ScrollableCards>
      </NoRowsWrapper>
    </div>
  );
};

export default RequestAttachmentsCards;
